import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteAthlete(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteAthlete = (athleteId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`athletes/${athleteId}/`);
  };

  return useMutation(deleteAthlete, {
    onSuccess: (_, athleteId) => {
      queryClient.invalidateQueries({
        predicate: query => query.queryKey[0] === 'athletes' && query.queryKey[1] !== athleteId,
      });
    },
  });
}
